<div class="flex flex-col h-full">
  @if (!router.url.includes('verify-business')) {
    <app-kyb-banner />
  }
  <app-header [navItems]="navItems" [needsBeneficiarySetup]="needsBeneficiarySetup()" />

  <!-- Main Content -->
  <main class="flex-1 p-4 md:p-6 bg-bg container-with-scroll">
    <div class="mx-auto container-lg">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-mobile-navbar [navItems]="navItems" [currentRole]="currentRole() ?? ''" [needsBeneficiarySetup]="needsBeneficiarySetup()" />
</div>
